import { AxiosResponse } from 'axios';
import { SearchFnReturn, useBaseList } from '../hook/useBaseList';
import { IProducts, ProductsFilters } from '../models/interfaces';
import { useApi } from '../context/useApi';
import { convertStringsToSort } from '../utils/sort';
import { useTranslation } from 'react-i18next';
import { List } from '../shared/list';

interface Props {
  clusterId: string;
}
const ProductClusterDetail = ({ clusterId }: Props) => {
  const { defaultApi } = useApi();
  const { t } = useTranslation();
  const searchClusterizedFn = async (
    page: number,
    size: number,
    filters: ProductsFilters,
    sort?: string[],
  ): Promise<SearchFnReturn<IProducts>> => {
    const filter: ProductsFilters = { cluster_id: clusterId };
    let resp: AxiosResponse<any>;
    if (sort && sort.length > 0) {
      resp = await defaultApi.toReviewClusteredPost({
        params: { page: page, size: size, sort },
        data: filter,
      });
    } else {
      resp = await defaultApi.toReviewClusteredPost({
        params: { page: page, size: size },
        data: filter,
      });
    }

    if (resp.status === 200) {
      return { count: resp.data?.data.totalElements ?? 0, list: resp.data.data?.content ?? [] };
    } else {
      throw Error('Errore');
    }
  };

  const {
    list: clusterizedList,
    page: clusterizedPage,
    pageSize: clusterizedPageSize,
    count: clusterizedCount,
    isLoading: clusterizedLoading,
    isPreviousData: clusterizedPreviousData,
    handlePageChange: clusterizedHandlePageChange,
    handlePageSizeChange: clusterizedHandlePageSizeChange,
    sort: clusterizedSort,
    onSortClick: clusterizedOnSortClick,
    filtersForm: clusterizedfiltersFormformProps,
  } = useBaseList<IProducts, ProductsFilters>({
    searchFn: searchClusterizedFn,
    apiOptions: { cacheTime: 20000 },
    defaultFilters: {},
    filterStoreKey: clusterId,
  });

  return (
    <>
      <List
        maxheight="calc(100vh - 20px)"
        list={clusterizedList}
        count={clusterizedCount}
        page={clusterizedPage}
        pageSize={clusterizedPageSize}
        loading={clusterizedLoading}
        isPreviousData={clusterizedPreviousData}
        onPageChange={clusterizedHandlePageChange}
        onPageSizeChange={clusterizedHandlePageSizeChange}
        gridTemplateColumns={'1fr 1fr 1fr 2.5fr 1.5fr 1fr 1fr 0.7fr 0.4fr 0.5fr 1fr 0.5fr'}
        keyGetter={(e: any) => e.id as string}
        sortBy={convertStringsToSort(clusterizedSort)}
        onSortClick={clusterizedOnSortClick}
        onItemClick={() => {
        }}
        fields={[
          {
            title: t('product.clusterId'),
            key: 'cluster_id',
            sortable: false,
          },
          {
            title: t('product.supplierCode'),
            key: 'codice_fornitore',
            sortable: false,
          },
          {
            title: t('product.manufacturerRef'),
            key: 'ref_produttore',
            sortable: false,
            tooltip: true,
          },
          {
            title: t('product.productName'),
            key: 'nome_prodotto',
            sortable: false,
            tooltip: true,
          },
          {
            title: t('product.supplierName'),
            key: 'nome_fornitore',
            sortable: false,
            tooltip: true,
          },
          {
            title: t('product.managementId'),
            key: 'id_gestionale',
            sortable: false,
          },
          {
            title: t('product.structureId'),
            key: 'id_struttura',
            sortable: false,
          },
          {
            title: t('product.unitPrice'),
            key: 'prezzo_unitario',
            sortable: false,
          },
          {
            title: t('product.upc'),
            key: 'upc',
            sortable: false,
          },
          {
            title: t('product.rdm'),
            key: 'rdm',
            sortable: false,
          },
          {
            title: t('product.cnd'),
            key: 'cnd',
            sortable: false,
          },
          {
            title: t('product.udi'),
            key: 'udi',
            sortable: false,
          },
        ]}
        emptyListMessage={t('info.noResult')}
        keepRecentlyOpenedItem
        // lastOpenedItem={lastOpenedItem}
      />
    </>
  );
};

export default ProductClusterDetail;
